import { VatDeclarationSubmission } from '../../../types/vatDeclarationSubmission'
import { SubmissionStatus } from '../enums/submissionStatus'
import { SubmitStatus } from '../enums/submitStatus'

const STATUS_CODE_RANGES = {
  DELIVERY: { MIN: 100, MAX: 199 },
  AUTH_1: { MIN: 200, MAX: 299 },
  AUTH_2: { MIN: 400, MAX: 499 },
  VALIDATION_1: { MIN: 300, MAX: 399 },
  VALIDATION_2: { MIN: 500, MAX: 599 },
}

const isDeliveryCode = (code: number): boolean =>
  code >= STATUS_CODE_RANGES.DELIVERY.MIN && code <= STATUS_CODE_RANGES.DELIVERY.MAX

const isAuthCode = (code: number): boolean =>
  (code >= STATUS_CODE_RANGES.AUTH_1.MIN && code <= STATUS_CODE_RANGES.AUTH_1.MAX) ||
  (code >= STATUS_CODE_RANGES.AUTH_2.MIN && code <= STATUS_CODE_RANGES.AUTH_2.MAX)

const isValidationCode = (code: number): boolean =>
  (code >= STATUS_CODE_RANGES.VALIDATION_1.MIN && code <= STATUS_CODE_RANGES.VALIDATION_1.MAX) ||
  (code >= STATUS_CODE_RANGES.VALIDATION_2.MIN && code <= STATUS_CODE_RANGES.VALIDATION_2.MAX)

interface GetSubmissionTimelineStatusArgs {
  code: string
  index: number
  submission: VatDeclarationSubmission
}

export const getSubmissionTimelineStatus = ({
  code,
  index,
  submission,
}: GetSubmissionTimelineStatusArgs): SubmissionStatus => {
  const numericCode = Number(code)

  if (isNaN(numericCode)) {
    return SubmissionStatus.UnknownError
  }

  if (index === 0 && submission?.status === SubmitStatus.Success) {
    return SubmissionStatus.Completed
  }

  let baseStatus: SubmissionStatus | null = null

  if (isDeliveryCode(numericCode)) {
    baseStatus = SubmissionStatus.Delivery
  } else if (isAuthCode(numericCode)) {
    baseStatus = SubmissionStatus.Authentication
  } else if (isValidationCode(numericCode)) {
    baseStatus = SubmissionStatus.Validation
  }

  if (index === 0 && submission?.status === SubmitStatus.Failed) {
    switch (baseStatus) {
      case SubmissionStatus.Delivery:
        return SubmissionStatus.DeliveryFailed
      case SubmissionStatus.Authentication:
        return SubmissionStatus.AuthenticationFailed
      case SubmissionStatus.Validation:
        return SubmissionStatus.ValidationFailed
      default:
        return SubmissionStatus.UnknownError
    }
  }

  return baseStatus ?? SubmissionStatus.UnknownError
}
